import { render, staticRenderFns } from "./CustomerSupportChatList.vue?vue&type=template&id=6f3f614a&"
import script from "./CustomerSupportChatList.vue?vue&type=script&lang=js&"
export * from "./CustomerSupportChatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports